import React from 'react';
import { ConfigProvider } from './context/ConfigContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './components/Dashboard.jsx';
import Members from './components/Members';
import Payments from './components/Payments';
import Donations from './components/Donations';
import Reports from './components/Reports';
import Events from './components/Events';
import Notifications from './components/Notifications';
import Settings from './components/Settings'; // Importar el nuevo componente Settings
import MembershipTypes from './components/MembershipTypes'; // Importar gestión de membresías
import NotificationContainer from './components/NotificationContainer';
import { useAuthContext } from './context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthContext();
  
  // Mostrar loading mientras verifica la sesión
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verificando sesión...</p>
        </div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <ConfigProvider>
      <Router>
        <AuthProvider>
          <NotificationProvider>
            <NotificationContainer />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/*" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="members" element={<Members />} />
                <Route path="payments" element={<Payments />} />
                <Route path="donations" element={<Donations />} />
                <Route path="reports" element={<Reports />} />
                <Route path="events" element={<Events />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="membership-types" element={<MembershipTypes />} /> {/* Ruta para Tipos de Membresía */}
                <Route path="settings" element={<Settings />} /> {/* Ruta para Settings */}
              </Route>
            </Routes>
          </NotificationProvider>
        </AuthProvider>
      </Router>
    </ConfigProvider>
  );
};

export default App;